import ChangePassword from "../Page/ChangePassword/ChangePassword";
import Dashboard from "../Page/Dashboard/Dashboard";
import Login from "../Page/Login/Login";
import Notification from "../Page/Notification/Notification";
import Posts from "../Page/Posts/Posts";
import UserDetails from "../Page/UserDetails/UserDetails";
import Users from "../Page/Users/Users";
import Excercise from "../Page/Excercise/Excercise";
import Reports from "../Page/Reports/Reports";
import ReportDetails from "../Page/Reports/ReportDetails";

export const publicRouters = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
];

export const privateRouters = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/users", element: <Users /> },
  { path: "/user_details/:id", element: <UserDetails /> },
  { path: "/change_password", element: <ChangePassword /> },
  { path: "/all_post", element: <Posts /> },
  { path: "/notification", element: <Notification /> },
  { path: "/excercise", element: <Excercise /> },
  { path: "/reports", element: <Reports /> },
  { path: "/report_details/:id", element: <ReportDetails /> },
];
